// @ts-check
import axios from 'axios'

const BASE = '/api/work/telehealth/phone-book'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['PhoneBookEntry']} PhoneBookEntry */
/** @typedef {Schemas['PhoneBookEntryCreateRequest']} PhoneBookEntryCreateRequest */
/** @typedef {Schemas['PhoneBookEntryDuplicate']} PhoneBookEntryDuplicate */
/** @typedef {Schemas['PatchedPhoneBookEntryUpdateRequest']} PhoneBookEntryUpdateRequest */
/** @typedef {import('./schema').operations['telehealth_phone_book_list']['parameters']['query']} PhoneBookListQuery */

/**
 * GET /api/work/telehealth/phone-book/ — phone book entries for the current tenant.
 * @param {PhoneBookListQuery} [params]
 * @returns {Promise<PhoneBookEntry[]>}
 */
export async function listPhoneBookEntries(params) {
  const { data } = await axios.get(`${BASE}/`, { params })
  return data
}

/**
 * POST /api/work/telehealth/phone-book/ — add an phone book entry. A number already in the
 * phone book rejects with 409 and an PhoneBookEntryDuplicate body carrying the existing entry.
 * @param {PhoneBookEntryCreateRequest} body
 * @returns {Promise<PhoneBookEntry>}
 */
export async function createPhoneBookEntry(body) {
  const { data } = await axios.post(`${BASE}/`, body)
  return data
}

/**
 * PATCH /api/work/telehealth/phone-book/{entryId}/ — update or deactivate (is_active=false) an entry (admin only).
 * @param {number} entryId
 * @param {PhoneBookEntryUpdateRequest} body
 * @returns {Promise<PhoneBookEntry>}
 */
export async function updatePhoneBookEntry(entryId, body) {
  const { data } = await axios.patch(`${BASE}/${entryId}/`, body)
  return data
}
